import React, { useEffect } from "react";
import LayoutComponent from "./Layout.component";
import { useLocation } from "react-router-dom";

const STANDALONE_MAIN_PATH = [
    "/my",
    "/follow",
    "/wannabe",
    "/casting/message/",
    "/block",
];
const NO_MENU_PATH = [
    "/my/notice/",
    "/student/profile/public/essential-info/edit",
    "/student/profile/public/additional-info/edit",
    "/student/profile/public/body-info/height/edit",
    "/student/profile/public/body-info/weight/edit",
    "/student/profile/public/body-info/shoe-size/edit",
    "/profile/agency/intro-video",
    "/student/profile/agency/photo/face/front",
    "/student/profile/agency/photo/face/left",
    "/student/profile/agency/photo/face/right",
    "/student/profile/agency/photo/full-body/front",
    "/student/profile/agency/photo/full-body/left",
    "/student/profile/agency/photo/full-body/right",
    "/student/hub/magazine/",
];

const LayoutContainer = (props: any) => {
    const location = useLocation();
    const needStandaloneMain = STANDALONE_MAIN_PATH.some(path => location.pathname.includes(path));
    const needNoMenu = NO_MENU_PATH.some(path => location.pathname.includes(path));
    const hideHeader = location.pathname.startsWith("/student/signup");

    return <LayoutComponent needStandaloneMain={needStandaloneMain} needNoMenu={needNoMenu} hideHeader={hideHeader} />;
};

export default LayoutContainer;
